var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:{
    'item--md': _vm.isMD,
    'item--sm': _vm.isSM,
    'item--active': _vm.isActive,
    customForResult: _vm.isCustomForResult
  }},[_vm._v(" "+_vm._s(_vm.getValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }